<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HLKBAS/tc-custom/9781459232556.jpg?1720083899709" alt="This image is the cover for the book Secret Cinderella"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret Cinderella
      </h1>
      <p class="bookDescription body article font2">
        <b>DESPERATELY SEEKING PRINCE CHARMING</b><br/><br/>Her desperate plan to save her brother left Melanie Andrews with a dead body on her hands, a killer at her heels and nowhere to runexcept into Roderick Laughlin’s arms. As soon as she saw the seductive, self-made man in the crowded ballroom, she knew she’d found a temporary haven. And as the clock struck twelve, Melanie pressed a burning kiss on his lips and escaped into the night, thinking she’d never see him again.<br/><br/>She thought wrong.<br/><br/>The taste of her was seared into his mind, and there was nowhere Roderick’s mysterious Cinderella could hide. Because she’d gotten mixed up in a deadly game, one only Roderick could protect her fromas soon as he convinced her he was the only man to trust.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dani Sinclair
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2f7565e7